interface LogoProps {
  className?: string;
  /** When true, the logo is decorative (e.g. alongside "I'd Go Back" text) and hidden from screen readers */
  decorative?: boolean;
}

export const Logo = ({
  className = 'size-8',
  decorative = true,
}: LogoProps) => {
  return (
    <div className={`${className} rounded-xl overflow-hidden shadow-sm shrink-0`}>
      <img
        src="/icon.png"
        alt={decorative ? '' : "I'd Go Back logo"}
        aria-hidden={decorative || undefined}
        className="size-full object-cover"
        draggable={false}
      />
    </div>
  );
};
